<header class="d-flex align-items-center justify-content-between mb-3 flex-wrap">
  <div>
    <h1 class="h3 mb-0">{{title}}</h1>
  </div>
  <ul class="nav nav-tabs" role="tablist" aria-label="Reports Tabs">
    <!-- <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === ''" href="#" (click)="selectTab('', $event)">Dashboard</a>
    </li> -->
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === 'call_log_report'" href="#" (click)="selectTab('call_log_report', $event)">Call Log Report</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === 'voucher_balances'" href="#" (click)="selectTab('voucher_balances', $event)">Voucher Balances Report</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === 'activity_report'" href="#" (click)="selectTab('activity_report', $event)">Activity Report</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === 'reports_builder'" href="#" (click)="selectTab('reports_builder', $event)">Reports Builder</a>
    </li>
  </ul>
</header>
